import React from 'react'
import * as Modal from '_components/modal/generic-modal'
import { Typography } from '@material-ui/core'
import useStyles from './styles'
import PropTypes from 'prop-types'

export function BudgetChoiceModal({ isOpen, onClose, onCreateInApp, onSendPdf }) {
  const styles = useStyles()
  return (
    <Modal.Root open={isOpen} onClose={onClose}>
      <Modal.Content>
        <Modal.WarningIcon />

        <Typography className={styles.title}>Como você deseja criar o orçamento?</Typography>
        <Typography className={styles.subtitle}>
          Você pode preencher os dados diretamente no sistema ou anexar um arquivo PDF externo.
        </Typography>
      </Modal.Content>
      <Modal.Actions style={{ justifyContent: 'center' }}>
        <Modal.ButtonRed onClick={onClose}>Cancelar</Modal.ButtonRed>
        <Modal.ButtonBlue onClick={onSendPdf}>Enviar arquivo PDF</Modal.ButtonBlue>
        <Modal.ButtonFullBlue onClick={onCreateInApp}>Criar pelo sistema</Modal.ButtonFullBlue>
      </Modal.Actions>
    </Modal.Root>
  )
}

BudgetChoiceModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreateInApp: PropTypes.func.isRequired,
  onSendPdf: PropTypes.func.isRequired,
}
